import React from 'react';
import { useDispatch } from 'react-redux';
import { showSuccessAlert, showCriticalAlert } from '../actions/common.actions';

export const useAlert = () => {
    const dispatch = useDispatch();
    const success = React.useCallback((msg: string) => {
        dispatch(showSuccessAlert(msg) as any);
    }, []);
    const error = React.useCallback((msg: string) => {
        dispatch(showCriticalAlert(msg) as any);
    }, []);

    return React.useMemo(
        () => ({
            success,
            error
        }),
        []
    );
};
